import { render, staticRenderFns } from "./LoginWx.vue?vue&type=template&id=4f9a63af&scoped=true&"
import script from "./LoginWx.vue?vue&type=script&lang=js&"
export * from "./LoginWx.vue?vue&type=script&lang=js&"
import style0 from "./LoginWx.vue?vue&type=style&index=0&id=4f9a63af&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9a63af",
  null
  
)

export default component.exports